import { WorkFlow } from "../masterdata/models/workFlow";

export class DeliveryBoxDetails {
    sender: string;
    deliveryStatus: string;
    delivery: string;
    httpStatus: number;
    title: string;
    message: string;
}

export class DeliveryBoxReception {
   sender: string;
   delivery: string;
   lab: string;
   labName:string;
   workFlow:WorkFlow;
   puid: string;
   creationDate:Date;
   lastModifiedDate:Date;
   receptionDateTime:Date;
   
}